export const TEST_IDS = {
    newProviderButton: 'providers-button-new',
    table: {
        id: "providers-table",
    },
    newProviderFields: {
        substance: 'newProviderForm-input-substance',
        chemicalAndComercialName: 'newProviderForm-input-chemicalAndComercialName',
        cuit: 'newProviderForm-input-cuit',
        type: 'newProviderForm-input-type'
    }
};
